import { app_subscription_hdr_RowClass } from '../../dbschema/app_subscription_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class SubscriptionModel extends BaseContainerModel {
  app_subscription_hdr: app_subscription_hdr_RowClass = new app_subscription_hdr_RowClass();
}
